import { z } from "zod";

export const loginSchema = (t: (key: string) => string) =>
  z.object({
    email: z.string().email(t("email-invalid")),
    password: z.string().min(6, t("password-min")),
  });

export type LoginFormValues = z.infer<ReturnType<typeof loginSchema>>;

export const magicLoginSchema = (t: (key: string) => string) =>
  z.object({
    email: z.string().email(t("email-invalid")),
  });

export type MagicLoginFormValues = z.infer<ReturnType<typeof magicLoginSchema>>;

export const recoverSchema = (t: (key: string) => string) =>
  z.object({
    email: z.string().email(t("email-invalid")),
  });

export type RecoverFormValues = z.infer<ReturnType<typeof recoverSchema>>;

export const setPasswordSchema = (t: (key: string) => string) =>
  z
    .object({
      newPassword: z.string().min(6, t("password-min")),
      confirmPassword: z.string().min(6, t("password-min")),
    })
    .refine((data) => data.newPassword === data.confirmPassword, {
      message: t("passwords-mismatch"),
      path: ["confirmPassword"],
    });

export type SetPasswordFormValues = z.infer<
  ReturnType<typeof setPasswordSchema>
>;
